import { date } from "is_js";

const AiToolsService = {
  analyzeJobDescription: async formData => {
    const payload = {
      email: formData.email,
      name: formData.name,
      text: formData.text
    };
    const url =
      'https://codersden.app.n8n.cloud/webhook/4694cbb7-cfbb-45d5-9221-44a2db69de7c';
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      throw new Error(
        `Failed running analyzeJobDescription: ${response.status}`
      );
    }

    const data = await response.json();
    console.log('Analyzed job description:', data);
    return data[0].summary;
  }
};

export default AiToolsService;
